import { useJsApiLoader } from "@react-google-maps/api";

// Single shared libraries array — must never change between renders.
// Includes all libraries needed across all map components.
const GOOGLE_MAPS_LIBRARIES = ["places"];

export const useGoogleMaps = () => {
  return useJsApiLoader({
    googleMapsApiKey: window.__RUNTIME_CONFIG__?.GOOGLE_MAPS_API_KEY || "",
    libraries: GOOGLE_MAPS_LIBRARIES,
  });
};
